import { addDays } from "date-fns/addDays";
import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
const HOTEL_IDS = [
    0,
    1,
    2,
    3,
    4
];
const defaultTravelers = {
    adults: 2,
    children: 0,
    childrenAges: {},
    rooms: 1,
    lapInfants: 0
};
function getMultiHotelTravelerState(travelers = defaultTravelers) {
    return {
        adults: travelers.adults ?? defaultTravelers.adults,
        children: travelers.children ?? defaultTravelers.children,
        childrenAges: travelers.childrenAges ?? defaultTravelers.childrenAges,
        rooms: travelers.rooms ?? defaultTravelers.rooms,
        lapInfants: 0
    };
}
function getFirstUnusedId(hotels) {
    const unusedId = HOTEL_IDS.find((id)=>!hotels.some((hotel)=>hotel.id === id));
    if (void 0 === unusedId) throw new Error('No available hotel IDs');
    return unusedId;
}
function getInitialMultiHotelState(startDate, endDate, endLocation) {
    return {
        hotels: [
            {
                endLocation,
                startDate,
                endDate,
                id: 0
            },
            {
                startDate: '',
                endDate: '',
                endLocation: null,
                id: 1
            }
        ],
        travelers: getMultiHotelTravelerState()
    };
}
function getMultiHotelInitialValues(initialData) {
    const today = new Date();
    const startDate = initialData?.startDate || format(today, 'yyyyMMdd');
    const startDateParsed = parse(startDate, 'yyyyMMdd', today);
    const endDate = initialData?.endDate || format(addDays(startDateParsed, 1), 'yyyyMMdd');
    const endLocation = initialData?.endLocation ?? null;
    const baseState = getInitialMultiHotelState(startDate, endDate, endLocation);
    const travelers = initialData?.travelers ?? baseState.travelers;
    return {
        ...baseState,
        travelers: getMultiHotelTravelerState(travelers)
    };
}
function setMultiHotels(hotels, data, index) {
    return hotels.map((hotel, hotelIndex)=>hotelIndex === index ? {
            ...hotel,
            ...data
        } : hotel);
}
function addMultiHotelDestination(hotels) {
    if (hotels.length > 4) return null;
    return [
        ...hotels,
        {
            endLocation: null,
            startDate: hotels.at(-1)?.endDate ?? '',
            endDate: '',
            id: getFirstUnusedId(hotels)
        }
    ];
}
function removeMultiHotelDestination(hotels, index) {
    return hotels.filter((_, hotelIndex)=>hotelIndex !== index);
}
export { addMultiHotelDestination, getInitialMultiHotelState, getMultiHotelInitialValues, getMultiHotelTravelerState, removeMultiHotelDestination, setMultiHotels };
